import { CardsTableHeadArrowUp } from 'components/CardsTable/components/CardsTableColumnsHead/svgs/CardsTableHeadArrowUp/CardsTableHeadArrowUp';
import { CardsTableHeadArrowDown } from 'components/CardsTable/components/CardsTableColumnsHead/svgs/CardsTableHeadArrowDown/CardsTableHeadArrowDown';
import { SortOrder } from 'types/interfaces/sort';
import './SortDirectionToggle.css';

interface Props {
  direction: SortOrder;
  /** Flip ascending <-> descending. The field selection is unchanged. */
  onToggle: () => void;
}

/**
 * Single-button toggle showing the active sort direction with the same arrow
 * glyphs as the cards-table column headers (▲ ascending / ▼ descending).
 */
const SortDirectionToggle = ({ direction, onToggle }: Props) => {
  const isAsc = direction === 'asc';

  return (
    <button
      type="button"
      className="sort-direction-toggle"
      onClick={onToggle}
      aria-label={isAsc ? 'Sort ascending' : 'Sort descending'}
      title={isAsc ? 'Ascending' : 'Descending'}
    >
      <span className="sort-direction-toggle-arrow">
        {isAsc ? (
          <CardsTableHeadArrowUp isSelected />
        ) : (
          <CardsTableHeadArrowDown isSelected />
        )}
      </span>
    </button>
  );
};

export default SortDirectionToggle;
